<div class="get-labels-actions" data-testid="get-labels-actions">
  @if (cancelAvailable()) {
    <div class="get-labels-actions__cancel">
      <puro-button
        type="button"
        variant="secondary"
        size="large"
        data-testid="get-labels-cancel-shipment"
        (buttonClick)="onCancel()"
      >
        {{ 'createShipment.getLabels.actions.cancelShipment' | translate }}
      </puro-button>
      <puro-typography component="p" variant="body2" class="get-labels-actions__deadline">
        {{
          'createShipment.getLabels.actions.cancelDeadline'
            | translate: { date: formattedDeadline() }
        }}
      </puro-typography>
    </div>
  }

  <puro-button
    type="button"
    variant="primary"
    size="large"
    data-testid="get-labels-create-new"
    (buttonClick)="onCreateNew()"
  >
    {{ 'createShipment.getLabels.actions.createNewShipment' | translate }}
  </puro-button>
</div>
